import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';

export const AccreditationRequirements = () => {
  return (
    <DynamicContent
      configPath={
        REMOTE_CONFIG_PATHS.MERCHANT_POLICY.SECTIONS.ACCREDITATION_REQUIREMENTS
      }
      renderAsHtml={true}
    />
  );
};
